module.exports = __webpack_public_path__ + "img/Samuel.907d1c23.jpg";